function animations_es_classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function animations_es_defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function animations_es_createClass(Constructor, protoProps, staticProps) {
  if (protoProps) animations_es_defineProperties(Constructor.prototype, protoProps);
  if (staticProps) animations_es_defineProperties(Constructor, staticProps);
  return Constructor;
}

function animations_es_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function animations_es_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function animations_es_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      animations_es_ownKeys(source, true).forEach(function (key) {
        animations_es_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      animations_es_ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Promisified version of window.requestAnimationFrame.
 * @returns {Promise} Promise will resolve when requestAnimationFrame callback is run.
 */
function raf() {
  return new Promise(function (resolve) {
    window.requestAnimationFrame(resolve);
  });
}
/**
 * Represents an HTML element with associate states
 */

var Animation =
  /*#__PURE__*/
  (function () {
    /**
     * @param {Object} options
     * @param {HTMLElement}  options.el Target element
     * @param {String} [options.state=initial] Initial state. This is also the default state.
     * @param {String} [options.stateAttribute=data-revealer] Attribute name to update with state.
     * @param {String} [options.stateChangeAttribute=data-revealer-transition] Attribute name to
     * update with change of state.
     * @param {String} [options.endEvent=transitionend] Event to listen for at end of state change.
     * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
     * next state change.
     * @param {Function} [options.onStart] Callback to execute immediate after
     * applying stateChangeAttribute.
     */
    function Animation(options) {
      animations_es_classCallCheck(this, Animation);

      this._el = options.el;
      this.cancelRunning = null;
      this._state = options.state || 'initial';
      this.initialState = this._state;
      this.stateAttribute = options.stateAttribute || 'data-animation-state';
      this.stateChangeAttribute = options.stateChangeAttribute || 'data-animation';
      this.endEvent = options.endEvent || 'transitionend';
      this.hold = !!options.hold;

      this.onStart =
        options.onStart ||
        function () {
          /* do nothing */
        };

      this.activeEventHandler = null;
    }
    /**
     * Returns target element
     *
     * @return {HTMLElement} Target element
     */

    animations_es_createClass(Animation, [
      {
        key: 'isState',

        /**
         * Check if a state is active
         * @param {String} state State to compare
         *
         * @return {Boolean}
         */
        value: function isState(state) {
          return state === this._state;
        },
        /**
         * Sequences a change to a new state.
         * @param {String} state Target state
         *
         * @param {Boolean} options.force Switch to final state immediately
         *
         * @param {Function} options.onStart Callback to execute immediately after
         * applying stateChangeAttribute for this state change only.
         *
         * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
         * next state change.
         *
         * @return {Promise} Resolves when endEvent triggered
         */
      },
      {
        key: 'animateTo',
        value: function animateTo(state) {
          var _this = this;

          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var from = this._el.dataset[this.stateAttribute] || this._state;
          var to = state || this.initialState;
          var force = options.force;
          var hold = 'hold' in options ? options.hold : this.hold;
          return new Promise(function (resolve) {
            if (_this.cancelRunning) {
              _this.cancelRunning();
            }

            if (from === to) {
              // Removing this here fixes some lingering attributes. But why?
              _this._el.removeAttribute(_this.stateChangeAttribute);

              resolve(from, null);
              return;
            }

            var running = true;

            _this.cancelRunning = function () {
              running = false;
              resolve(null, null);
            };

            _this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

            _this.activeEventHandler = null;

            if (force) {
              _this._el.setAttribute(_this.stateChangeAttribute, ''.concat(from, '=>').concat(to));

              _this.onStart({
                el: _this._el,
                from: from,
                to: to,
              });

              if (typeof options.onStart === 'function') {
                options.onStart({
                  el: _this._el,
                  from: from,
                  to: to,
                });
              }

              _this._el.setAttribute(_this.stateAttribute, to);

              _this._state = to;

              if (!hold) {
                _this._el.removeAttribute(_this.stateChangeAttribute);
              }

              resolve(to, null);
              return;
            }

            raf()
              .then(function () {
                if (!running) throw new Error('cancelled');

                _this._el.setAttribute(_this.stateChangeAttribute, ''.concat(from, '=>').concat(to));

                _this.onStart({
                  el: _this._el,
                  from: from,
                  to: to,
                });

                if (typeof options.onStart === 'function') {
                  options.onStart({
                    el: _this._el,
                    from: from,
                    to: to,
                  });
                }

                return raf();
              })
              .then(function () {
                if (!running) throw new Error('cancelled');

                _this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

                _this.activeEventHandler = function (e) {
                  // Ignore any events bubbling up
                  if (e.target !== _this._el || !running) return;

                  _this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

                  if (!hold) {
                    _this._el.removeAttribute(_this.stateChangeAttribute);
                  }

                  resolve(to, e);
                };

                _this._el.addEventListener(_this.endEvent, _this.activeEventHandler);

                _this._el.setAttribute(_this.stateAttribute, to);

                _this._state = to;
              })
              ['catch'](function (error) {
                // Only catch 'cancelled' errors.
                if (error.message !== 'cancelled') throw error;
              });
          });
        },
        /**
         * Remove any event listeners
         */
      },
      {
        key: 'unload',
        value: function unload() {
          this._el.removeEventListener(this.endEvent, this.activeEventHandler);

          this.activeEventHandler = null;
        },
      },
      {
        key: 'el',
        get: function get() {
          return this._el;
        },
        /**
         * Returns current state
         *
         * @return {String} Current state
         */
      },
      {
        key: 'state',
        get: function get() {
          return this._state;
        },
      },
    ]);

    return Animation;
  })();

export { Animation };
